module.exports = __webpack_public_path__ + "img/login.e448e87b.png";